import { ApiErrors } from '../enums';
export function mapBilletErrorToMessage(error, t) {
    const errorCode = error.result?.error || error.result?.errorCode;
    switch (errorCode) {
        case ApiErrors.BILLET_ALREADY_PAID:
        case ApiErrors.ERROR_BILLET_ALREADY_PAID:
        case ApiErrors.ERROR_CAN_NOT_PAY_BILLET_AGAIN:
        case 'PAY1201102':
        case 'PAY1201108':
            return t('barcode-has-already-been-used-error');
        case ApiErrors.BILLET_EXPIRED:
        case ApiErrors.ERROR_BILLET_EXPIRED:
        case ApiErrors.ERROR_CAN_NOT_PAY_BILLET_EXPIRED:
        case 'PAY1201106':
        case 'PAY1201107':
            return t('billet-duedate-has-passed-error');
        case ApiErrors.CAN_NOT_FIND_BILLET:
        case 'PAY1201101':
            return t('barcode-not-registered-in-system-error');
        case ApiErrors.CAN_NOT_PAY_BILLET:
        case 'PAY1201103':
            return t('billet-was-canceled-by-the-issuer-error');
        case ApiErrors.BILLET_GENERIC:
            return t('invalid-code-billet-not-found-error');
        case ApiErrors.PIN_FAILURE_TO_VALIDATE:
            return t('pin-failure-to-validate-error');
        case ApiErrors.CAN_NOT_SCHEDULE_INVALID_DAY:
            return t('schedule-cannot-invalid-day-error-message');
        case ApiErrors.CAN_NOT_SCHEDULE_BANK_SLIP:
            return t('schedule-bank-lip-error-message');
        default:
            return t('invalid-code-billet-not-found-error');
    }
}
export function mapDepositBilletErrorToMessage(error, t) {
    if (isTransformedApiError(error)) {
        const result = error.details?.result;
        const errorCode = result?.code ?? result?.error ?? result?.errorCode;
        switch (errorCode) {
            case ApiErrors.NO_FUNDS_AVAILABLE:
            case ApiErrors.ERROR_NO_FUNDS_AVAILABLE:
                return t('deposit-billet.errors.no-funds-available');
            case ApiErrors.PIX_KEY_NOT_FOUND:
                return t('deposit-billet.errors.pix-key-not-found');
            default:
                return t('deposit-billet.errors.generic');
        }
    }
    if (isFetchBaseQueryError(error)) {
        switch (error.status) {
            case 'FETCH_ERROR':
                return t('deposit-billet.errors.network-error');
            case 'TIMEOUT_ERROR':
                return t('deposit-billet.errors.timeout-error');
            case 'PARSING_ERROR':
                return t('deposit-billet.errors.parsing-error');
            default:
                return t('deposit-billet.errors.generic');
        }
    }
    return t('deposit-billet.errors.generic');
}
function isTransformedApiError(error) {
    return typeof error === 'object' && error !== null && 'message' in error && 'details' in error;
}
function isFetchBaseQueryError(error) {
    return (typeof error === 'object' &&
        error !== null &&
        'status' in error &&
        typeof error.status === 'string');
}
